import ResourcesFrame from "./ResourceFrame";
import ResourceLink from "./ResourceLink";

export { ResourceLink };


export default ResourcesFrame;